import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLuaDark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 56,
	viewBox: "0 0 57 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M24.6197 11.2C19.2093 11.2 14.0205 13.3493 10.1947 17.175C6.36901 21.0008 4.21973 26.1896 4.21973 31.6C4.21973 37.0104 6.36901 42.1992 10.1947 46.025C14.0205 49.8507 19.2093 52 24.6197 52C27.2987 52 29.9514 51.4723 32.4265 50.4471C34.9015 49.4219 37.1504 47.9193 39.0447 46.025C40.939 44.1307 42.4417 41.8818 43.4669 39.4067C44.4921 36.9317 45.0197 34.279 45.0197 31.6C45.0197 26.1896 42.8704 21.0008 39.0447 17.175C35.219 13.3493 30.0301 11.2 24.6197 11.2ZM31.8197 30.4C30.2284 30.4 28.7023 29.7679 27.5771 28.6426C26.4519 27.5174 25.8197 25.9913 25.8197 24.4C25.8197 22.8087 26.4519 21.2826 27.5771 20.1574C28.7023 19.0321 30.2284 18.4 31.8197 18.4C33.411 18.4 34.9371 19.0321 36.0624 20.1574C37.1876 21.2826 37.8197 22.8087 37.8197 24.4C37.8197 25.9913 37.1876 27.5174 36.0624 28.6426C34.9371 29.7679 33.411 30.4 31.8197 30.4ZM46.2197 4C44.6284 4 43.1023 4.63214 41.9771 5.75736C40.8519 6.88258 40.2197 8.4087 40.2197 10C40.2197 11.5913 40.8519 13.1174 41.9771 14.2426C43.1023 15.3679 44.6284 16 46.2197 16C47.0077 16 47.7879 15.8448 48.5158 15.5433C49.2438 15.2417 49.9052 14.7998 50.4624 14.2426C51.0195 13.6855 51.4615 13.0241 51.763 12.2961C52.0645 11.5681 52.2197 10.7879 52.2197 10C52.2197 8.4087 51.5876 6.88258 50.4624 5.75736C49.3372 4.63214 47.811 4 46.2197 4Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgLuaDark);
export { ForwardRef as ReactComponent };
